<template>   
    <div id="tradeModal" class="float-right">
        
        <a id="importTradesBtn" v-bind:class="primbtn"  href="#" v-on:click="importTrades()">
            <i class="fa fa-arrow-circle-o-down"></i> Trades
        </a>
        <a class="btn btn-success" href="#" v-on:click="showAddTrade()">
            <i class="fa fa-plus-circle"></i> Trade
        </a>
        <b-modal id="addModal" title="Add Trade" @ok="saveHolding">
            <b-form>
                <b-form-group id="input-group-2" label="Security:" label-for="input-2">
                    <autocomplete :search="searchInput"
                                  placeholder="Security"
                                  aria-label="Security"
                                  :get-result-value="getResultValue"
                                  @submit="handleSubmit"></autocomplete>
                </b-form-group>

                <b-form-group id="input-group-1"
                              label="Trade date:"
                              label-for="input-1">

                    <b-form-datepicker id="example-datepicker" v-model="newHolding.trade_Date" class="mb-2"></b-form-datepicker>
                </b-form-group>

                <b-form-group id="input-group-3" label="Buy / Sell:" label-for="input-3">
                    <b-form-select id="input-3"
                                   v-model="newHolding.buy_Sell"
                                   :options="tradeTypes"
                                   required></b-form-select>
                </b-form-group>
                <b-form-group id="input-group-2" label="Units:" label-for="input-2">
                    <b-form-input id="input-2"
                                  v-model.number="newHolding.units"
                                  required
                                  placeholder="Units" autocomplete="off"></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-2" label="Price:" label-for="input-2">
                    <b-form-input id="input-2"
                                  v-model.number="newHolding.average_Price"
                                  required
                                  placeholder="Price" autocomplete="off"></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-2" label="Brokerage:" label-for="input-2">
                    <b-form-input id="input-2"
                                  v-model.number="newHolding.brokerage_inc_GST"
                                  required
                                  placeholder="Brokerage" autocomplete="off"></b-form-input>
                </b-form-group>
            </b-form>
        </b-modal>

        <b-modal id="editModal" title="Edit Trade" @ok="saveHolding">
            <b-form>
                <b-form-group id="input-group-1"
                              label="Trade date:"
                              label-for="input-1">
                    <b-form-datepicker id="example-datepicker" v-model="holding.trade_Date" class="mb-2"></b-form-datepicker>
                </b-form-group>

                <b-form-group id="input-group-3" label="Buy / Sell:" label-for="input-3">
                    <b-form-select id="input-3"
                                   v-model="holding.buy_Sell"
                                   :options="tradeTypes"
                                   required></b-form-select>
                </b-form-group>
                <b-form-group id="input-group-2" label="Units:" label-for="input-2">
                    <b-form-input id="input-2"
                                  v-model.number="holding.units"
                                  required
                                  placeholder="Units"></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-2" label="Price:" label-for="input-2">
                    <b-form-input id="input-2"
                                  v-model.number="holding.average_Price"
                                  required
                                  placeholder="Price"></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-2" label="Brokerage:" label-for="input-2">
                    <b-form-input id="input-2"
                                  v-model.number="holding.brokerage_inc_GST"
                                  required
                                  placeholder="Brokerage"></b-form-input>
                </b-form-group>
            </b-form>
        </b-modal>
    </div>         

</template>



<script>
    import axios from 'axios';
    
    

    export default {
        props: {
            portfolioguid: String,
            securityprop: String,
            marketprop: Number
        },
        data: function () {
            return {
                modalTitle: "Add Trade",
                securities: [],
                tradeTypes: [{ text: 'Select One', value: null }, { text: 'Buy', value: 'B' }, { text: 'Sell', value: 'S' }],
                parentMessage: 'Parent',
                items: [],
                dividends: [],
                portfolioGuid: this.portfolioguid,
                isIndividual: this.securityprop != undefined,
                newHolding: {
                    trade_Date: "",
                    buy_Sell: "B",
                    security: this.securityprop,
                    units: 0,
                    marketId: parseInt(this.marketprop),
                    average_Price: 0,
                    brokerage_inc_GST: 0,
                    portfolioGuid: this.portfolioguid
                },
                holding: {},
                security: this.securityprop,
                primbtn: "btn btn-primary"
            }
        },
        async mounted() {

        },
        methods: {
            async importTrades() {

                await axios.post('/tradeImporter/StakeImport', null, {
                    params: {
                        fUserName: "1", fPassword: "2"
                    }
                });

                this.primbtn = "btn btn-primary btn-outline-warning";

                this.LoadData();
                
            },            
            showAddTrade() {
                this.holding = this.newHolding;
                this.holding.portfolioGuid = this.portfolioGuid;
                if (this.isIndividual) {                    
                    this.$bvModal.show('editModal');
                } else {
                    this.$bvModal.show('addModal');
                }
                
            },
            editTrade(trade) {
                this.holding = trade;
                this.holding.portfolioGuid = this.portfolioGuid;
                this.$bvModal.show('editModal')
            },
            getData(obj) {
                console.log(obj);
            },
            searchInput(input) {
                const url = "/api/securities/GetByFilter?q=" + input + "&count=20"

                return new Promise(resolve => {
                    if (input.length < 2) {
                        return resolve([])
                    }

                    fetch(url)
                        .then(response => response.json())
                        .then(data => {
                            resolve(data)
                        })
                })
            },

            getResultValue(result) {
                return "[" + result.market.code + "] (" + result.code + ") " + result.name;
            },

            handleSubmit(result) {
                this.newHolding.security = result.code;
                this.newHolding.marketId = result.marketId;
            },
            resetHolding: function () {
                this.newHolding.trade_Date = "";
                this.newHolding.buy_Sell = "B";
                //this.newHolding.security = "";
                this.newHolding.units = 0;
                this.newHolding.average_Price = 0;
                this.newHolding.brokerage_inc_GST = 0;
                this.newHolding.rowGuid = null;
            },            
            saveHolding: function () {
                var self = this;                

                if (self.holding.rowGuid != null) {

                    axios.post('/api/trades/edittrade', self.holding)
                        .then(function () {
                            //self.getTrades();
                            self.$emit('my-event');
                        })
                        .catch(function (error) {
                            console.log(error);
                        });

                } else {
                    axios.post('/api/trades/addtrade', self.newHolding)
                        .then(function () {
                            self.resetHolding();
                            self.$emit('my-event');
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            }            
        }
    }
</script>